import { useEffect, useRef } from "react";
import LeadCapturedDraggableNudge from "../../DraggableNudge/LeadCapturedDraggableNudge";
const LeadNudgeArea = ({
    nudgeMode,
    customizeState,
    nudgeId,
    setNudgePosition,
    setCustomizeState,
  }) => {
    const draggableDesktopRef = useRef(null);
  
    useEffect(() => {
      if (draggableDesktopRef.current) {
        let width = draggableDesktopRef.current.offsetWidth;
        draggableDesktopRef.current.height = `${Math.round(
          width / 2.057
        )}px !important`;
      }
    }, []);
  
    return (
      <>
        {nudgeMode === "desktop" ? (
          <div
            ref={draggableDesktopRef}
            className={`desktop__drag__area m-2 rounded border dark:!border-neutral-500 !border-[#0c0c0c] relative  shadow-md shadow-[#203b69]`}
            style={{
              position: "relative",
              overflow: "hidden",
              height: "573px",
            }}
          >
            <LeadCapturedDraggableNudge
              key="desktop"
              customizeState={customizeState}
              nudgeId={nudgeId}
              id="desktop"
              setNudgePosition={setNudgePosition}
              setCustomizeState={setCustomizeState}
            />
          </div>
        ) : (
          <div
            className={`mobile__drag__area m-2 rounded border dark:!border-neutral-500 !border-[#0c0c0c] relative mx-auto shadow-md shadow-[#203b69]`}
            style={{
              position: "relative",
              overflow: "hidden",
              minHeight: "844px",
              maxWidth: "340px",
            }}
          >
            <LeadCapturedDraggableNudge
              key="mobile"
              customizeState={customizeState}
              nudgeId={nudgeId}
              id="mobile"
              setNudgePosition={setNudgePosition}
              setCustomizeState={setCustomizeState}
            />
          </div>
        )}
      </>
    );
};
  
export default LeadNudgeArea;